import { render, staticRenderFns } from "./kindChooseViewp.vue?vue&type=template&id=59bb58ea&scoped=true"
import script from "./kindChooseViewp.vue?vue&type=script&lang=js"
export * from "./kindChooseViewp.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewp.vue?vue&type=style&index=0&id=59bb58ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb58ea",
  null
  
)

export default component.exports